function Footer() {
    return(
        <footer>LEDGER SERVIÇOS EM TECNOLOGIA LTDA. CNPJ 34.472.252/0001-35<br/>
        contato@ledegertec.com.br</footer>
    )
}

export default Footer;